<template>
  <modal
    v-slot="{ data }"
    name="read-only-menu-item-modal"
    @closed="closedHandler"
  >
    <menu-item
      :is-read-only="data.isReadOnly"
      @added="addedHandler"
      @updated="updatedHandler"
    />
  </modal>
</template>



<script>
  import events from '@/services/events';

  import { mapGetters } from 'vuex';


  export default {
    name: 'MenuItemModal',

    computed: {
      ...mapGetters('menu', ['selectedItem'])
    },

    methods: {
      addedHandler() {
        this.$closeModal('menuItem');
      },

      closedHandler() {
        this.$store.dispatch('menu/selectItem', {
          itemId: null,
          orderItemId: null
        });

        this.$store.dispatch('menu/selectCategory', null);

        events.emit('menu-item-modal:close');
      },

      updatedHandler() {
        this.$closeModal('menuItem');
      }
    }
  };
</script>
